import React, { useState, useEffect } from 'react';
import { createStyles, Flex, Title, Box, Group, Center, SegmentedControl, Grid } from '@mantine/core';
import TotalEmissions from '../dashboard/TotalEmissions';
import TotalDistance from '../dashboard/TotalDistance';
import TotalTime from '../dashboard/TotalTime';
import TotalBenefits from '../dashboard/TotalBenefits';
import RegisteredUsers from '../dashboard/RegisteredUsers';
import UserEvolution from '../dashboard/UserEvolution';
import UserMap from '../dashboard/UserMap';
import ActiveUsers from '../dashboard/ActiveUsers';
import useDasboardApi from '../../hooks/useDashboardApi';
import BenefitInformation from '../dashboard/BenefitInformation';
import BenefitPerformance from '../dashboard/BenefitPerformance';
import Posts from '../dashboard/Posts';

// Custom styles
const useStyles = createStyles((theme) => ({
	container: {
		padding: theme.spacing.md,
		height: '100%',
	},
	cardTitle: {
		fontWeight: 700,
		fontSize: 16,
		lineHeight: '20px',
	},
	floatingPurple: {
		position: 'absolute',
		backgroundColor: '#F2E8FA',
		top: -16,
		left: -16,
		right: -16,
		bottom: -16,
		zIndex: 0,
		display: theme.colorScheme === 'dark' ? 'none' : 'block'
	}
}));

const Home = () => {

	// State and hooks
	const { classes } = useStyles();
	const [tab, setTab] = useState('users');
	const { getUserTypes } = useDasboardApi();

	// On load
	useEffect(() => {
		async function fetchData() {
			await getUserTypes();
		}
		fetchData();
		// eslint-disable-next-line
	}, []);

	return (
		<Box className="mainContainer">
			{/* Content */}
			<Flex
				direction="column"
				justify="space-between"
				className={classes.container}
			>
				{/* Purple Container */}
				<Box
					sx={{ position: 'relative' }}
				>
					{/* Floating Purple */}
					<Box className={classes.floatingPurple}>&nbsp;</Box>
					{/* Title */}
					<Title
						fw={500}
						mb="xl"
						pos="relative"
						sx={(theme) => ({
							color: theme.colorScheme === 'light' ? '#4A4A4A' : '#C1C2C5',
						})}
					>
						Datos Generales
					</Title>
					{/* Cards */}
					<Group
						grow
						spacing={30}
						align="flex-start"
						pos="relative"
					>
						{/* Savings */}
						<TotalEmissions />
						{/* Distance */}
						<TotalDistance />
						{/* Time */}
						<TotalTime />
						{/* Benefits */}
						<TotalBenefits />
					</Group>
				</Box>
				{/* Tabs */}
				<Center
					my={50}
					sx={(theme) => ({
						backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[0],
					})}
				>
					<SegmentedControl
						value={tab}
						onChange={setTab}
						size="md"
						color="mainPurple"
						radius={18}
						data={[
							{ label: 'Usuarios', value: 'users' },
							{ label: 'Beneficios', value: 'benefits' },
							{ label: 'Noticias', value: 'posts' },
						]}
					/>
				</Center>
				{/* Content */}
				{tab === 'users' ?
					// Users
					<>
						<Grid gutter={30}>
							{/* Left */}
							<Grid.Col span={7}>
								{/* Registered */}
								<RegisteredUsers />
								{/* Active */}
								<ActiveUsers />
							</Grid.Col>
							{/* Right */}
							<Grid.Col span={5}>
								{/* Evolution */}
								<UserEvolution />
								{/* Map */}
								<UserMap />
							</Grid.Col>
						</Grid>
					</>
				: tab === 'benefits' ?
					// Benefits
					<>
						<Grid gutter={30}>
							{/* Left */}
							<Grid.Col span={7}>
								{/* Information */}
								<BenefitInformation />
							</Grid.Col>
							{/* Right */}
							<Grid.Col span={5}>
								{/* Performance */}
								<BenefitPerformance />
							</Grid.Col>
						</Grid>
					</>
				: tab === 'posts' ?
					<Posts />
				: null}
			</Flex>
		</Box>
	);

}

export default Home;
